import { createAxiosInstance } from '../utils/helpers'
import { API_URL } from './index'
import * as types from './types'

import { displayMessages } from './common'

export function getPlantillas(page = 1) {
	const axios = createAxiosInstance()
	return (dispatch, getState) => {
		const showRecords = getState().plantillas.get('showRecords')
		const orderBy = getState().plantillas.get('orderBy')
		const filters = getState().plantillas.getIn(['modalFilter', 'filters']).filter(x => x.get('apply')).toJS()

		axios.get(`${API_URL}/plantillas`, { params: { page, showRecords, orderBy, filters }})
		.then((res) => {
			const data = res.data.data.map(x => {
				x.visible = true
				x.selected = false
				return x
			})
			const totalRecords = Number(res.data.totalRecords)
			const fn1 = d => d({ type: types.OBTENER_PLANTILLAS, payload: { data, page, totalRecords } })
			fn1(dispatch)
		})
		.catch((err) => {
			displayMessages(dispatch, err)
		})
	}
}

export function changeRecordsToShow(showRecords) {
    return (dispatch) => {
        const fn0 = (d) => d({ type: types.CAMBIAR_MOSTRAR_REGISTROS_PLANTILLAS, payload: showRecords })
        const fn1 = (d) => d(getPlantillas(1))
        fn0(dispatch)
        fn1(dispatch)
    }
}

export function toggleSelectItem(index, checked) {
	return (dispatch, getState) => {
		dispatch({ type: types.CONMUTAR_SELECCION_PLANTILLA, payload: { index, checked } })
	}
}

export function toggleSelectAllItems(checked) {
	return (dispatch) => {
		dispatch({ type: types.CONMUTAR_SELECCION_TODOS_PLANTILLAS, payload: checked })
	}
}

export function filterPlantillas(term) {
	return (dispatch) => {
		dispatch({ type: types.FILTRAR_PLANTILLAS, payload: term })
	}
}

export function setOrderBy(field) {
	return (dispatch, getState) => {
		let current = getState().plantillas.get('orderBy')
		current = current.set('field', field.Value)
		if (field === null) {
			current = current.set('asc', false)
		} else {
			current = current.set('asc', !current.get('asc'))
		}

        const fn0 = (d) => d({ type: types.ORDENAR_PLANTILLAS, payload: { orderBy: current } })
        const fn1 = (d) => d(getPlantillas(1))
        fn0(dispatch)
        fn1(dispatch)
	}
}

export function displayModalCreate(show, title, mode, id) {
	return (dispatch, getState) => {
		const user = getState().common.get('user')
		dispatch({ type: types.MOSTRAR_MODAL_CREAR_PLANTILLA, payload: { show, title, mode, id, user } })
	}
}

export function updateInputs(path, value) {
	return (dispatch) => {
		dispatch({ type: types.MODIFICAR_INPUTS_PLANTILLAS, payload: { path, value } })
	}
}

export function createOrUpdatePlantillas(data, mode) {
	const axios = createAxiosInstance()
	return (dispatch) => {
		const fn0 = (d) => d({ type: types.DESHABILITAR_BOTON_MODAL_PLANTILLAS, payload: true })
		const fn1 = (d) => d({ type: types.DESHABILITAR_BOTON_MODAL_PLANTILLAS, payload: false })
		fn0(dispatch)

		if (mode === 'create') {
			axios.post(`${API_URL}/plantillas`, data.toJS())
				.then(res => {
					const plantilla = res.data
					plantilla.visible = true
					plantilla.selected = false
					dispatch({ type: types.CREAR_ACTUALIZAR_PLANTILLA, payload: plantilla })
					displayMessages(dispatch, { success: 'El plantilla ha sido guardado exitosamente' })
					fn1(dispatch)
				})
				.catch(err => {
					console.log(err)
					displayMessages(dispatch, err)
					fn1(dispatch)
				})
		} else if (mode === 'edit') {
			axios.put(`${API_URL}/plantillas/${data.get('id')}`, data.toJS())
				.then(res => {
					const plantilla = res.data
					plantilla.visible = true
					plantilla.selected = false
					dispatch({ type: types.CREAR_ACTUALIZAR_PLANTILLA, payload: plantilla })
					displayMessages(dispatch, { success: 'El plantilla ha sido actualizado exitosamente' })
					fn1(dispatch)
				})
				.catch(err => {
					console.log(err)
					displayMessages(dispatch, err)
					fn1(dispatch)
				})
		}
	}
}

export function showHideModalDelete(open, message = null, action = null) {
	return (dispatch) => {
		dispatch({ type: types.MOSTRAR_MODAL_CONFIRMAR_ELIMINACION_PLANTILLA, payload: { open, message, action } })
	}
}

export function deletePlantillas() {
	const axios = createAxiosInstance()
	return (dispatch, getState) => {
		const selected = getState().plantillas.get('plantillas').filter(x => x.get('selected')).map(x => x.get('id'))
		const fns = []
		selected.forEach(x => {
			const fn = () => axios.delete(`${API_URL}/plantillas/${x}`)
			fns.push(fn)
		})

		const toResultObject = (promise) => {
			return promise
			.then(result => ({ success: true, result }))
			.catch(error => ({ success: false, error }));
		}

		Promise.all(fns.map(x => x()).map(toResultObject))
		.then(res => {
			const succeded = []
			const failed = []
			res.forEach(x => {
				if (!x.success) {
					failed.push(x.error.response.data.ExceptionMessage)
				} else {
					succeded.push(x.result.data.nombre)
					dispatch({ type: types.ELIMINAR_PLANTILLA, payload: x.result.data.id })
				}
			})
			if (succeded.length > 0) displayMessages(dispatch, { success: 'Se han eliminado los siguentes plantillas: ' + succeded.join(', ') })
			if (failed.length > 0) displayMessages(dispatch, { response: { status: 500, data: failed.join('\n') } })
		})
	}
}

export function showHideModalFilter(state) {
    return (dispatch) => {
        dispatch({ type: types.MOSTRAR_MODAL_CRITERIOS_FILTRADO_PLANTILLAS, payload: state })
    }
}

export function addModalFilterCriteria() {
    return (dispatch) => {
        dispatch({ type: types.ADICIONAR_CRITERIO_FILTRADO_PLANTILLAS })
    }
}

export function removeCheckedModalFilterCriterias() {
    return (dispatch) => {
        dispatch({ type: types.ELIMINAR_CRITERIO_FILTRADO_PLANTILLAS })
    }
}

export function toggleCheckedModalFilterCriterias(index, checked) {
    return (dispatch) => {
        dispatch({ type: types.CONMUTAR_SELECCION_CRITERIO_FILTRADO_PLANTILLAS, payload: { index, checked } })
    }
}

export function updateModalFilterCriteria(index, attr, value) {
    return (dispatch) => {
        dispatch({ type: types.MODIFICAR_CRITERIO_FILTRADO_PLANTILLAS, payload: { index, attr, value } })
    }
}

export function applyFilterCriterias() {
    return (dispatch) => {
        const fn0 = (d) => d({ type: types.APLICAR_CRITERIOS_FILTRADO_PLANTILLAS })
        const fn1= (d) => d(getPlantillas(1))
        fn0(dispatch)
        fn1(dispatch)
    }
}


// WEBPACK FOOTER //
// ./src/actions/plantillas.js